import styled from 'styled-components';

export const InputErrorMessage = styled(`p`)`
	margin-bottom: 0;
	color: rgb(255, 77, 79);
	font-size: 14px;
`;
